import { render } from "./ServicePerformanceModal.vue?vue&type=template&id=193c01fb&scoped=true&ts=true"
import script from "./ServicePerformanceModal.vue?vue&type=script&lang=ts"
export * from "./ServicePerformanceModal.vue?vue&type=script&lang=ts"

import "./ServicePerformanceModal.vue?vue&type=style&index=0&id=193c01fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193c01fb"]])

export default __exports__